export default {
    auth: {
        login: {
            buttons: {
                enter: '입장하기',
                otherStudent: '다른 학생으로 입장하기',
                otherClassroom: '다른 학급으로 입장하기',
                pwa: '바로가기 만들기',
            },
            pwa: {
                title: '앱처럼 홈 화면에 바로가기를 만들까요?',
                description: '앞으로는 학급 코드 없이 바로 입장할 수 있어요!',
                install: {
                    ios: 'Safari 브라우저 하단의 "공유" 버튼을 누른 후 "홈 화면에 추가"를 선택하세요.',
                    android: '브라우저 메뉴(⋮)를 누른 후 "앱 설치"를 선택하세요.',
                    default: '브라우저 메뉴에서 "홈 화면에 추가" 또는 "앱 설치"를 선택하세요.',
                },
                buttons: {
                    next: '다음에 할게요',
                    create: '바로가기 만들기',
                },
            },
            pinSet: 'PIN 번호가 설정됐어요! 수업에 입장해 주세요.',
            stepClassroom: {
                title: '학생 입장하기',
                description: '선생님이 공유해주신 우리 학급 코드를 입력해 주세요!',
            },
            stepPin: {
                studentInfo: '{number}번 {name}',
                input: '수업에 입장하려면 PIN 번호를 입력하세요.',
                set: '수업에 입장하려면 PIN 번호를 설정하세요.',
                retry: '다시 한 번 PIN 번호를 입력하세요.',
                tip: '수업에 입장할 때 PIN 번호가 필요하니 잊지 말고 꼭 기억해 주세요!',
                error: {
                    confirm: 'PIN 번호가 일치하지 않아요! 다시 한 번 확인하고 입력해 주세요.',
                    unknown: '알 수 없는 오류가 발생했습니다.',
                    pin: 'PIN 번호를 확인할 수 없습니다.',
                    set: 'PIN 번호를 설정할 수 없습니다.',
                },
            },
            stepStudent: {
                title: '출석번호와 이름을 입력해 주세요!',
                placeholder: {
                    number: '출석 번호를 입력하세요(숫자)',
                    name: '이름을 입력하세요. (한글)',
                },
                error: {
                    nameKorean: '한글만 입력할 수 있어요.',
                    number: '숫자만 입력할 수 있어요.',
                    unknown: '알 수 없는 오류가 발생했습니다.',
                },
            },
        },
    },
};
